// components
import DashboardIcon from "@mui/icons-material/Dashboard";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import FormatListNumberedOutlinedIcon from "@mui/icons-material/FormatListNumberedOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import LocalActivityOutlinedIcon from "@mui/icons-material/LocalActivityOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import PointOfSaleOutlinedIcon from "@mui/icons-material/PointOfSaleOutlined";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
// routes
import { PATH_DASHBOARD } from "../../routes/paths";

export const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "General",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.general.root,
      },
      {
        title: "Settings",
        path: PATH_DASHBOARD.general.settings,
      },
    ],
  },
  {
    subheader: "Reservations",
    items: [
      {
        title: "All Bookings",
        path: PATH_DASHBOARD.bookings,
      },
      {
        title: "Add Booking",
        path: PATH_DASHBOARD.addBookings,
      },
    ],
  },
  {
    subheader: "Listings",
    items: [
      {
        title: "All Listings",
        path: PATH_DASHBOARD.listings,
      },
      {
        title: "Calendar",
        path: PATH_DASHBOARD.calendar,
      },
      {
        title: "Add Listing",
        path: PATH_DASHBOARD.addListings,
      },
    ],
  },
  {
    subheader: "Administrative",
    items: [
      {
        title: "Staff",
        path: PATH_DASHBOARD.staff,
      },
      {
        title: "Staff Roles",
        path: PATH_DASHBOARD.roles,
      },
      {
        title: "Reports",
        path: PATH_DASHBOARD.reports,
      },
    ],
  },
  {
    subheader: "Terminals",
    items: [
      {
        title: "Linked Terminals",
        path: PATH_DASHBOARD.terminals,
        icon: <PointOfSaleOutlinedIcon />,
      },
      {
        title: "Request",
        path: PATH_DASHBOARD.terminalRequests,
        icon: <PendingActionsOutlinedIcon />,
      },
    ],
  },
  {
    subheader: "",
    items: [
      {
        title: "Transactions",
        path: PATH_DASHBOARD.transactions,
      },
      {
        title: "Earnings",
        path: PATH_DASHBOARD.earnings,
      },
      {
        title: "Wallet",
        path: PATH_DASHBOARD.wallet,
      },
      {
        title: "Messages",
        path: PATH_DASHBOARD.messages,
      },
      {
        title: "Reviews",
        path: PATH_DASHBOARD.reviews,
      },
      {
        title: "Notifications",
        path: PATH_DASHBOARD.general.notification,
      },
      {
        title: "Insights",
        path: PATH_DASHBOARD.insights,
      },
      {
        title: "Refer a Friend",
        path: PATH_DASHBOARD.referral,
      },
      {
        title: "Activity Logs",
        path: PATH_DASHBOARD.logs,
      },
    ],
  },
];
export const eventSidebarConfig = [
  {
    subheader: "General",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.general.root,
        icon: <DashboardIcon />,
      },
      {
        title: "Settings",
        path: PATH_DASHBOARD.general.settings,
        icon: <SettingsOutlinedIcon />,
      },
    ],
  },
  {
    subheader: "Tickets",
    items: [
      {
        title: "Guest List",
        path: PATH_DASHBOARD.tickets,
        icon: <GroupsOutlinedIcon />,
      },
      {
        title: "Ticket Types",
        path: PATH_DASHBOARD.ticketTypes,
        icon: <LocalActivityOutlinedIcon />,
      },
      {
        title: "Checked In",
        path: PATH_DASHBOARD.checkedIn,
        icon: <HowToRegOutlinedIcon />,
      },
      {
        title: "Add Ticket",
        path: PATH_DASHBOARD.addTicket,
        icon: <AddCircleOutlineIcon />,
      },
    ],
  },
  {
    subheader: "Listings",
    items: [
      {
        title: "All Listings",
        path: PATH_DASHBOARD.listings,
        icon: <MenuBookOutlinedIcon />,
      },
      {
        title: "Add Listing",
        path: PATH_DASHBOARD.addListings,
        icon: <SummarizeOutlinedIcon />,
      },
      {
        title: "Reports",
        path: PATH_DASHBOARD.reports,
        icon: <AssessmentOutlinedIcon />,
      },
    ],
  },
  {
    subheader: "Administrative",
    items: [
      {
        title: "Staff",
        path: PATH_DASHBOARD.staff,
        icon: <SupervisorAccountOutlinedIcon />,
      },
      {
        title: "Staff Roles",
        path: PATH_DASHBOARD.roles,
        icon: <AdminPanelSettingsOutlinedIcon />,
      },
    ],
  },
  {
    subheader: "Terminals",
    items: [
      {
        title: "Linked Terminals",
        path: PATH_DASHBOARD.terminals,
        icon: <PointOfSaleOutlinedIcon />,
      },
      {
        title: "Request",
        path: PATH_DASHBOARD.terminalRequests,
        icon: <PendingActionsOutlinedIcon />,
      },
    ],
  },
  {
    subheader: "",
    items: [
      {
        title: "Transactions",
        path: PATH_DASHBOARD.transactions,
        icon: <ReceiptOutlinedIcon />,
      },
      {
        title: "Earnings",
        path: PATH_DASHBOARD.earnings,
        icon: <PaymentsOutlinedIcon />,
      },
      {
        title: "Wallet",
        path: PATH_DASHBOARD.wallet,
        icon: <AccountBalanceWalletOutlinedIcon />,
      },
      {
        title: "Messaging",
        path: PATH_DASHBOARD.messages,
        icon: <ChatOutlinedIcon />,
      },

      {
        title: "Notifications",
        path: PATH_DASHBOARD.general.notification,
        icon: <NotificationsActiveOutlinedIcon />,
      },
      {
        title: "Insights",
        path: PATH_DASHBOARD.insights,
        icon: <InsightsOutlinedIcon />,
      },
      {
        title: "Activity Logs",
        path: PATH_DASHBOARD.logs,
        icon: <FormatListNumberedOutlinedIcon />,
      },
    ],
  },
];
export const attractionSidebarConfig = [
  {
    subheader: "General",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.general.root,
        icon: <DashboardIcon />,
      },
      {
        title: "Settings",
        path: PATH_DASHBOARD.general.settings,
        icon: <SettingsOutlinedIcon />,
      },
    ],
  },
  {
    subheader: "Tickets",
    items: [
      {
        title: "Guest List",
        path: PATH_DASHBOARD.tickets,
        icon: <GroupsOutlinedIcon />,
      },
      {
        title: "Ticket Types",
        path: PATH_DASHBOARD.ticketTypes,
        icon: <LocalActivityOutlinedIcon />,
      },
      {
        title: "Checked In",
        path: PATH_DASHBOARD.checkedIn,
        icon: <HowToRegOutlinedIcon />,
      },
      {
        title: "Add Ticket",
        path: PATH_DASHBOARD.addTicket,
        icon: <AddCircleOutlineIcon />,
      },
    ],
  },
  {
    subheader: "Listings",
    items: [
      {
        title: "All Listings",
        path: PATH_DASHBOARD.listings,
        icon: <MenuBookOutlinedIcon />,
      },
      {
        title: "Calendar",
        path: PATH_DASHBOARD.calendar,
        icon: <DateRangeOutlinedIcon />,
      },
      {
        title: "Add Listing",
        path: PATH_DASHBOARD.addListings,
        icon: <SummarizeOutlinedIcon />,
      },
    ],
  },
  {
    subheader: "Administrative",
    items: [
      {
        title: "Staff",
        path: PATH_DASHBOARD.staff,
        icon: <SupervisorAccountOutlinedIcon />,
      },
      {
        title: "Staff Roles",
        path: PATH_DASHBOARD.roles,
        icon: <AdminPanelSettingsOutlinedIcon />,
      },
      {
        title: "Reports",
        path: PATH_DASHBOARD.reports,
      },
    ],
  },
  {
    subheader: "Terminals",
    items: [
      {
        title: "Linked Terminals",
        path: PATH_DASHBOARD.terminals,
        icon: <PointOfSaleOutlinedIcon />,
      },
      {
        title: "Request",
        path: PATH_DASHBOARD.terminalRequests,
        icon: <PendingActionsOutlinedIcon />,
      },
    ],
  },
  {
    subheader: "",
    items: [
      {
        title: "Transactions",
        path: PATH_DASHBOARD.transactions,
        icon: <ReceiptOutlinedIcon />,
      },
      {
        title: "Earnings",
        path: PATH_DASHBOARD.earnings,
        icon: <PaymentsOutlinedIcon />,
      },
      {
        title: "Wallet",
        path: PATH_DASHBOARD.wallet,
        icon: <AccountBalanceWalletOutlinedIcon />,
      },
      {
        title: "Messages",
        path: PATH_DASHBOARD.messages,
        icon: <ChatOutlinedIcon />,
      },
      {
        title: "Reviews",
        path: PATH_DASHBOARD.reviews,
        icon: <VisibilityOutlinedIcon />,
      },

      {
        title: "Notifications",
        path: PATH_DASHBOARD.general.notification,
        icon: <NotificationsActiveOutlinedIcon />,
      },
      {
        title: "Insights",
        path: PATH_DASHBOARD.insights,
        icon: <InsightsOutlinedIcon />,
      },
      {
        title: "Activity Logs",
        path: PATH_DASHBOARD.logs,
        icon: <FormatListNumberedOutlinedIcon />,
      },
    ],
  },
];
export const propertySidebarConfig = [
  {
    subheader: "General",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.general.root,
        icon: <DashboardIcon />,
      },
      {
        title: "Settings",
        path: PATH_DASHBOARD.general.settings,
        icon: <SettingsOutlinedIcon />,
      },
    ],
  },

  {
    subheader: "Listings",
    items: [
      {
        title: "All Listings",
        path: PATH_DASHBOARD.listings,
        icon: <MenuBookOutlinedIcon />,
      },
      {
        title: "Add Listing",
        path: PATH_DASHBOARD.addListings,
        icon: <SummarizeOutlinedIcon />,
      },
    ],
  },
  {
    subheader: "Administrative",
    items: [
      {
        title: "Staff",
        path: PATH_DASHBOARD.staff,
        icon: <SupervisorAccountOutlinedIcon />,
      },
      {
        title: "Staff Roles",
        path: PATH_DASHBOARD.roles,
        icon: <AdminPanelSettingsOutlinedIcon />,
      },
    ],
  },
  {
    subheader: "",
    items: [
      {
        title: "Leads",
        path: PATH_DASHBOARD.leads,
        icon: <VisibilityOutlinedIcon />,
      },
      {
        title: "Wallet",
        path: PATH_DASHBOARD.wallet,
        icon: <AccountBalanceWalletOutlinedIcon />,
      },
      {
        title: "Messages",
        path: PATH_DASHBOARD.messages,
        icon: <ChatOutlinedIcon />,
      },
      {
        title: "Reviews",
        path: PATH_DASHBOARD.reviews,
        icon: <VisibilityOutlinedIcon />,
      },
      {
        title: "Notifications",
        path: PATH_DASHBOARD.general.notification,
        icon: <NotificationsActiveOutlinedIcon />,
      },
      {
        title: "Insights",
        path: PATH_DASHBOARD.insights,
        icon: <InsightsOutlinedIcon />,
      },
      {
        title: "Activity Logs",
        path: PATH_DASHBOARD.logs,
        icon: <FormatListNumberedOutlinedIcon />,
      },
    ],
  },
];
